"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgCoordinates(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a3 3 0 012.23 5.007l2.757 4.256h2.84L20 11.49h-1.903l.341.67a4.729 4.729 0 01.326 3.515c.002.332-.456.451-.63.164l-2.607-4.349H13v.115a.38.38 0 01-.387.372h-1.227a.38.38 0 01-.387-.372v-.115H8.473l-2.609 4.349c-.173.287-.63.168-.628-.164a4.733 4.733 0 01.326-3.515l.341-.67H4V9.264h3.012l2.757-4.257A3 3 0 0112 0zm0 6l-.037-.001L9.94 9.263h1.448v-.115a.38.38 0 01.387-.371h.45a.38.38 0 01.387.371v.115h1.448L12.037 6zm0-4a1 1 0 100 2 1 1 0 000-2z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Coordinates')(SvgCoordinates);
//# sourceMappingURL=Coordinates.js.map